import { render, staticRenderFns } from "./AdsList.vue?vue&type=template&id=6661db51&"
import script from "./AdsList.vue?vue&type=script&lang=js&"
export * from "./AdsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports